/**
 *  Shopify'in serbest metin aramasi, terim sayisi arttikca kac terimin eslesmesi
 *  gerektigini yukseltiyor. Bu yuzden birden fazla barkod aratildiginda ana arama
 *  bos donuyor (5 barkod -> 0 sonuc), oysa onizleme alan bazli sorgu gonderdigi icin
 *  dogru sonuclari getiriyor. Salt barkod listelerini alan bazli sorguya cevirerek
 *  ana aramada da ayni sonuclari aliyoruz. Diger sorgular oldugu gibi birakilir.
 */
function buildBarcodeSearchQuery(value) {
  const tokens = value.split(/(?:\s+OR\s+|[\s,;]+)/i).filter(Boolean);

  if (tokens.length < 2 || !tokens.every((token) => /^\d{8,}$/.test(token))) {
    return value;
  }

  return tokens.map((token) => `variants.barcode:${token}`).join(' OR ');
}

// Header'daki arama formlari <search-form> icinde olmadigi icin kendi submit
// handler'lari yok; ayni donusumu onlar icin de burada uyguluyoruz.
document.addEventListener(
  'submit',
  (event) => {
    const form = event.target;

    if (!(form instanceof HTMLFormElement) || form.getAttribute('role') !== 'search') {
      return;
    }

    const input = form.querySelector('input[name="q"]');

    if (!input) {
      return;
    }

    const value = input.value.trim();

    // Explicit multi-term searches are handled field-agnostically by
    // batch-search.js. Keep this numeric transformation only as a fallback.
    if (window.ThemeBatchSearch?.parseTerms(value).length > 1) {
      return;
    }

    const query = buildBarcodeSearchQuery(value);

    if (query === value) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    window.location.href = `${form.action}?q=${encodeURIComponent(query)}`;
  },
  true
);

/**
 *  @class
 *  @function Predictive Search
 */
if (!customElements.get('search-form')) {
  class SearchForm extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.isLoggedIn = this.dataset.loggedin || false;
      this.container = document.getElementById('Search-Drawer');
      this.form = this.container.querySelector('form');
      this.input = this.container.querySelector('input[type="search"]');
      this.predictiveSearchResults = this.container.querySelector('.search-drawer--content');
      this.searchRequestId = 0;

      this.setupEventListeners();
    }

    setupEventListeners() {
      this.form.addEventListener('submit', this.onFormSubmit.bind(this));

      this.input.addEventListener('input', debounce((event) => {
        this.onChange(event);
      }, 500).bind(this));
    }

    getQuery() {
      return this.input.value.trim();
    }

    onChange() {
      const searchTerm = this.getQuery();

      if (!searchTerm.length) {
        this.searchRequestId += 1;
        this.predictiveSearchResults.innerHTML = '';
        this.predictiveSearchResults.classList.remove('loading');
        return;
      }
      this.predictiveSearchResults.classList.add('loading');
      this.requestSearchResults(searchTerm);
    }

    onFormSubmit(event) {
      if (!this.getQuery().length || this.checkStaticPagesAndRedirect(event.target)) {
        event.preventDefault();
        return;
      }
      
      // Form submit'i önle ve title: prefix'i ile yönlendir // kapatıldı
      event.preventDefault();
      const currentValue = this.input.value.trim();
      
      // const isOnlyNumbers = /^\d+$/.test(currentValue);
      // const isAlphaNumeric = /^[A-Za-z0-9\-\.\_]+$/.test(currentValue) && 
      //                       /[A-Za-z]/.test(currentValue) && /[0-9]/.test(currentValue);
      
      // const isProductCode = (isOnlyNumbers && currentValue.length >= 8) || 
      //                      (isAlphaNumeric && currentValue.length >= 3 && currentValue.length <= 20);
      
      // let searchQuery;
      // if (isProductCode) {
      //   searchQuery = currentValue;
      // } else if (currentValue.startsWith('title:')) {
      //   searchQuery = currentValue;
      // } else {
      //   searchQuery = `title:${currentValue}*`;
      // }
      
      window.location.href = `${this.form.action}?q=${encodeURIComponent(this.buildSearchQuery(currentValue))}`;
    }

    buildSearchQuery(value) {
      return buildBarcodeSearchQuery(value);
    }

    checkStaticPagesAndRedirect(formElement) {
      const searchTerm = formElement.querySelector('#side-panel-search-input')?.value || '';
      const lowerCaseSearchTerm = searchTerm?.toLocaleLowerCase();
      if (!lowerCaseSearchTerm) {
        return false;
      }

      const staticPagesObject = {
        "/pages/iade-ve-degisim": ["iade", "i̇ade", "kolay iade", "Kolay iade","KOLAY İADE"],
        "/pages/iletisim": ["iletisim", "iletisim sayfası", "i̇letisim sayfası", "i̇letisim"],
        "/pages/stores": ["mağaza", "mağazalarımız", "mağazalar", "mağaza sayfası", "magaza"],
        "/account?view=orders": ["sipariş", "siparişlerim","siparişim","sipariş sorgulama"],
      };

      for (const [url, keywords] of Object.entries(staticPagesObject)) {
        if (keywords.includes(lowerCaseSearchTerm)) {
          if(url.includes('/account') && !this.isLoggedIn) {
            window.open('https://destek.kigili.com.tr/siparis-sorgula', '_blank'); // logged in değilse sipariş sorgula sayfasını yeni sekmede aç
          } else {
            window.location.href = url;
          }
          return true;
        }
      }
      return false;
    }

    onFocus() {
      const searchTerm = this.getQuery();

      if (!searchTerm.length) {
        return;
      }

      this.requestSearchResults(searchTerm);
    }

    requestSearchResults(searchTerm) {
      const requestId = ++this.searchRequestId;
      const batchTerms = window.ThemeBatchSearch?.parseTerms(searchTerm) || [];

      if (batchTerms.length > 1) {
        this.getBatchSearchResults(searchTerm, batchTerms, requestId);
        return;
      }

      this.getSearchResults(searchTerm, requestId);
    }

    getSearchResultsMarkup(searchTerm) {
      const url = new URL(theme.routes.predictive_search_url, window.location.origin);
      url.searchParams.set('q', searchTerm);
      url.searchParams.set('resources[type]', 'product,collection,article,query,page');
      url.searchParams.set('resources[limit_scope]', 'each');
      url.searchParams.set('resources[limit]', '7');
      url.searchParams.set(
        'resources[options][fields]',
        'title,product_type,vendor,variants.title,variants.sku,tag,variants.barcode'
      );
      url.searchParams.set('section_id', 'predictive-search');

      return fetch(url.toString()).then((response) => {
        if (!response.ok) throw new Error(`Predictive search failed with status ${response.status}`);
        return response.text();
      });
    }

    getSearchResults(searchTerm, requestId) {

      this.predictiveSearchResults.classList.add('loading');

      this.getSearchResultsMarkup(searchTerm)
        .then((text) => {
          if (requestId !== this.searchRequestId) return;

          const section = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('#shopify-section-predictive-search');

          if (!section) throw new Error('Predictive search section was not found');

          this.renderSearchResults(section.innerHTML);
        })
        .catch((error) => {
          if (requestId !== this.searchRequestId) return;
          this.predictiveSearchResults.classList.remove('loading');
          console.error(error);
        });
    }

    async getBatchSearchResults(searchTerm, terms, requestId) {
      this.predictiveSearchResults.classList.add('loading');

      const responses = await window.ThemeBatchSearch.mapWithConcurrency(
        window.ThemeBatchSearch.uniqueTerms(terms),
        (term) => this.getSearchResultsMarkup(term)
      );

      if (requestId !== this.searchRequestId) return;

      const documents = responses
        .filter((result) => result.status === 'fulfilled')
        .map((result) => new DOMParser().parseFromString(result.value, 'text/html'));
      const products = window.ThemeBatchSearch.collectUniqueElements(
        documents,
        '.side-panel-content--tab-panel .search-drawer--products > product-card'
      );

      if (!products.length) {
        this.getSearchResults(searchTerm, requestId);
        return;
      }

      const fragment = document.createElement('div');
      const tabs = document.createElement('side-panel-content-tabs');
      const tabButton = document.createElement('button');
      const firstProductTab = documents
        .map((doc) => doc.querySelector('.side-panel-content--tabs button'))
        .find(Boolean);

      tabs.className = 'side-panel-content--tabs';
      tabButton.className = 'tab-active';
      tabButton.textContent = firstProductTab?.textContent.trim() || 'Products';
      tabs.appendChild(tabButton);
      fragment.appendChild(tabs);

      const panel = document.createElement('div');
      panel.className = 'side-panel-content--tab-panel tab-active';

      const scroll = document.createElement('theme-scroll');
      scroll.className = 'theme-scroll';
      scroll.setAttribute('data-overlayscrollbars-initialize', '');

      const productList = document.createElement('div');
      productList.className = 'search-drawer--products theme-scroll--inner';
      products.forEach((product) => productList.appendChild(product.cloneNode(true)));
      scroll.appendChild(productList);
      panel.appendChild(scroll);

      const showAll = document.createElement('div');
      showAll.className =
        'hp:mt-2.5 hp:lg:mt-6 hp:flex hp:justify-center hp:lg:static hp:sticky hp:bottom-0 hp:left-0 hp:max-md:shadow';

      const showAllLink = document.createElement('a');
      showAllLink.className = 'button hp:md:w-fit hp:w-full';
      showAllLink.href = window.ThemeBatchSearch.createSearchUrl(this.form.action, searchTerm).toString();
      showAllLink.textContent = theme.strings?.showMoreProducts || 'Show all products';
      showAll.appendChild(showAllLink);
      panel.appendChild(showAll);
      fragment.appendChild(panel);

      const loading = document.createElement('span');
      loading.className = 'loading-overlay small';
      fragment.appendChild(loading);

      this.renderSearchResults(fragment.innerHTML);
    }

    renderSearchResults(resultsMarkup) {
      this.predictiveSearchResults.innerHTML = resultsMarkup;
      this.predictiveSearchResults.classList.remove('loading');

      // Tüm ürün fotoğraflarını görünür hale getir
      const productImages = this.predictiveSearchResults.querySelectorAll('.animations-true .product-card--image-primary');
      const collectionLinks = this.predictiveSearchResults.querySelectorAll('.animations-true .collection-card--link');
      
      // Ürün fotoğrafları için Intersection Observer kullan
      if (productImages.length > 0) {
        const imageObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              gsap.to(entry.target, { 
                scale: 1, 
                opacity: 1, 
                duration: 0.6, 
                ease: window.theme.settings.animation_easing || "power2.out" 
              });
              imageObserver.unobserve(entry.target);
            }
          });
        }, {
          threshold: 0.1, // %10 görünür olduğunda tetikle
          rootMargin: '50px' // 50px önceden tetikle
        });

        productImages.forEach((image) => {
          imageObserver.observe(image);
        });

        // Alternatif: Tüm elementleri hemen görünür yap (Intersection Observer çalışmazsa)
        setTimeout(() => {
          return;
          productImages.forEach((image) => {
            if (image.style.opacity !== '1') {
              gsap.set(image, { scale: 1, opacity: 1 });
            }
          });
        }, 100);
      }

      // Collection linkleri için ScrollTrigger kullan (mevcut davranışı koru)
      if (collectionLinks.length > 0 && window.gsap && window.ScrollTrigger) {
        ScrollTrigger.batch(collectionLinks, {
          start: "top 90%",
          onEnter: (elements) => {
            gsap.to(elements, { scale: 1, opacity: 1, stagger: 0.15, ease: window.theme.settings.animation_easing });
          }
        });
      }
    }

    close() {
      this.container.classList.remove('active');
    }
  }
  customElements.define('search-form', SearchForm);
}
